<template>
  <v-container fluid>
    <v-layout text-xs-center wrap>
      <v-flex>
        <data-table-lang-level
          :students="filteredStudents"
          :loading="loading"
          :exportToCsv="exportToCsv"
          :downloadPdf="downloadPdf"
        />
      </v-flex>
      <snackbar
        :id="snackbar.id"
        :type="snackbar.type"
        :message="snackbar.message"
      />
    </v-layout>
  </v-container>
</template>

<script>
import DataTableLangLevel from '@/components/DataTableLangLevel';
import Snackbar from '@/components/Snackbar';
import axios from 'axios';
import uuid from 'uuid';

export default {
  components: {
    DataTableLangLevel,
    Snackbar,
  },
  data: () => ({
    students: undefined,
    filteredStudents: undefined,
    loading: false,
    reminderModalOpen: false,
    groupReminderModalOpen: false,
    sending: false,
    modalStudent: undefined,
    snackbar: {
      type: '',
      message: '',
      id: '',
    },
  }),
  async mounted() {
    this.loading = true;
    try {
      const { data: students } = await axios({
        method: 'GET',
        url: `${process.env.VUE_APP_API_URI}/lingo-log`,
      });
      this.students = students;
      this.filteredStudents = students;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.snackbar = {
        id: uuid(),
        type: 'error',
        message: 'Erreur de chargement',
      };
    }
  },
  methods: {
    exportToCsv: async function () {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${process.env.VUE_APP_API_URI}/lingo-log?format=xlsx`,
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lingo-log.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        this.snackbar = {
          id: uuid(),
          type: 'error',
          message: 'Erreur de chargement',
        };
      }
    },
    downloadPdf: async function (lang, email) {
      try {
        const { data } = await axios({
          method: 'post',
          data: { lang, email },
          url: `${process.env.VUE_APP_API_URI}/lingo-log`,
          responseType: 'arraybuffer',
        });
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lingo-log.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        this.snackbar = {
          id: uuid(),
          type: 'error',
          message: 'Erreur de chargement',
        };
      }
    },
  },
};
</script>
